<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Download Danfe PDF/XML</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="wrap-form-item">
          <div class="row">
            <div class="col-xs-12">
              <div class="form-item">
                <div class="row">
                  <div class="col-xs-12">
                    <fieldset class="wrap-title">
                      <h3 class="form-title">Download Danfe PDF/XML</h3>
                    </fieldset>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="wrap-product-detail search-danfe">
                      <div class="advance-info">
                        <div class="tab-control normal">
                          <a href="#pedido" class="tab-control-item active">Pesquisa por Número do Pedido</a>
                          <a href="#nota" class="tab-control-item">Pesquisa por Número da Nota Fiscal</a>
                        </div>
                        <div class="tab-contents">
                          <div class="tab-content-item active" id="pedido">
                            <form @submit.prevent="pesquisarPedido" name="frm-pesquisar-pedido">
                              <div class="col-xs-12 col-sm-8">
                                <fieldset class="wrap-input">
                                  <label for="pedido-num">Pedido</label>
                                  <input
                                    type="text"
                                    name="pedido-num"
                                    v-model="frmPesquisaPedido.pedido"
                                    :class="{ 'is-invalid': !isValidPedido.status && frmPesquisaPedido.attemptSubmit }"
                                    v-mask="'#######-#'"
                                  />
                                  <span v-if="!isValidPedido.status && frmPesquisaPedido.attemptSubmit" class="invalid-feedback">{{
                                    isValidPedido.message
                                  }}</span>
                                </fieldset>
                              </div>
                              <div class="col-xs-12 col-sm-4">
                                <div class="wrap-butons-line">
                                  <button aria-label="Pesquisar Pedido" class="btn btn-primary">Pesquisar Pedido</button>
                                </div>
                              </div>
                            </form>

                            <div
                              v-if="!this.frmPesquisaPedido.localizado && this.frmPesquisaPedido.attemptSubmit"
                              class="col-xs-12 resultado-nao-encontrado"
                            >
                              <h4>
                                <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                                Danfe não encontrado
                              </h4>
                            </div>

                            <div v-if="this.frmPesquisaPedido.localizado" class="col-xs-12 resultado">
                              <h4>
                                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                                Danfe encontrado
                              </h4>

                              <div class="files">
                                <a v-bind:href="frmPesquisaPedido.pdf" v-on:click.stop.prevent="setupDownload(false, 'frmPesquisaPedido', 'pdf', 'pdf', frmPesquisaPedido.chave)">
                                  <i class="fa fa-file-pdf-o fa-2x"></i> Download PDF
                                </a>
                                <a v-bind:href="frmPesquisaPedido.xml" v-on:click.stop.prevent="setupDownload(true, 'frmPesquisaPedido', 'xml', 'xml', frmPesquisaPedido.chave)">
                                  <i class="fa fa-file-code-o fa-2x"></i> Download XML
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="tab-content-item" id="nota">
                            <form @submit.prevent="pesquisarNf" name="frm-pesquisar-nf">
                              <div class="col-xs-8 col-sm-8">
                                <fieldset class="wrap-input">
                                  <label for="nota-num">Nota Fiscal</label>
                                  <input
                                    type="text"
                                    name="nota-num"
                                    v-model="frmPesquisaNota.nota"
                                    :class="{ 'is-invalid': !isValidNF.status && frmPesquisaNota.attemptSubmit }"
                                    v-mask="'########'"
                                  />
                                  <span v-if="!isValidNF.status && frmPesquisaNota.attemptSubmit" class="invalid-feedback">{{
                                    isValidNF.message
                                  }}</span>
                                </fieldset>
                              </div>
                              <div class="col-xs-4 col-sm-4">
                                <div class="wrap-butons-line">
                                  <button aria-label="Pesquisar Nota Fiscal" class="btn btn-primary">Pesquisar Nota Fiscal</button>
                                </div>
                              </div>
                            </form>
                            <div
                              v-if="!this.frmPesquisaNota.localizado && this.frmPesquisaNota.attemptSubmit"
                              class="col-xs-12 resultado-nao-encontrado"
                            >
                              <h4>
                                <i class="fa fa-thumbs-down" aria-hidden="true"></i>
                                Danfe não encontrado
                              </h4>
                            </div>

                            <div v-if="this.frmPesquisaNota.localizado" class="col-xs-12 resultado">
                              <h4>
                                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                                Danfe encontrado
                              </h4>

                              <div class="files">
                                <a v-bind:href="frmPesquisaNota.pdf" v-on:click.stop.prevent="setupDownload(false, 'frmPesquisaNota', 'pdf', 'pdf', frmPesquisaNota.chave)">
                                  <i class="fa fa-file-pdf-o fa-2x"></i> Download PDF
                                </a>
                                <a v-bind:href="frmPesquisaNota.xml" v-on:click.stop.prevent="setupDownload(true, 'frmPesquisaNota', 'xml', 'xml', frmPesquisaNota.chave)">
                                  <i class="fa fa-file-code-o fa-2x"></i> Download XML
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import DownloadDanfeService from '@/services/DownloadDanfeService'

export default {
  name: 'DownloadDanfe',
  props: {
    msg: String,
  },
  data() {
    return {
      frmPesquisaPedido: {
        pedido: null,
        pdf: '/download',
        xml: '/download',
        localizado: false,
        attemptSubmit: false,
        chave: null,
      },
      frmPesquisaNota: {
        nota: null,
        pdf: '/download',
        xml: '/download',
        localizado: false,
        attemptSubmit: false,
        chave: null,
      },
    }
  },
  computed: {
    isValidPedido: function () {
      const response = {}
      response.status = false
      response.message = 'Informe o número'
      this.frmPesquisaPedido.localizado = false

      if (this.frmPesquisaPedido.pedido == null || this.frmPesquisaPedido.pedido == '') {
        return response
      }

      response.status = true
      return response
    },
    isValidNF: function () {
      const response = {}
      response.status = false
      response.message = 'Informe o número'
      this.frmPesquisaNota.localizado = false

      if (this.frmPesquisaNota.nota == null || this.frmPesquisaNota.nota == '') {
        return response
      }

      response.status = true
      return response
    },
  },
  filters: {},
  methods: {
    pesquisarPedido: function (e) {
      // Verifica se os dados são válidos
      const self = this

      if (!this.isValidPedido.status) {
        return
      }

      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          this.frmPesquisaPedido.chave = xhr.responseText.replace(/"/g, '')
          this.frmPesquisaPedido.attemptSubmit = true
          this.frmPesquisaPedido.localizado = true
        } else if (xhr.status == 404) {
          this.frmPesquisaPedido.attemptSubmit = true
          this.frmPesquisaPedido.localizado = false
        } else if (xhr.status == 401) {
          swal({
            title: 'É necessário estar logado',
            icon: 'warning',
          }).then(() => (location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href))
        } else {
          swal({
            title: 'Erro ao buscar o pedido',
            icon: 'error',
          })
        }
      }

      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getpedidodanfe')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoPedido: this.frmPesquisaPedido.pedido.split('-')[0],
          codigoNotaFiscal: 0,
        })
      )
    },
    pesquisarNf: function (e) {
      // Verifica se os dados são válidos
      if (!this.isValidNF.status) {
        this.frmPesquisaNota.localizado = false
        return
      }

      const self = this
      const xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          this.frmPesquisaNota.chave = xhr.responseText.replace(/"/g, '')
          this.frmPesquisaNota.attemptSubmit = true
          this.frmPesquisaNota.localizado = true
        } else if (xhr.status == 404) {
          this.frmPesquisaNota.attemptSubmit = true
          this.frmPesquisaNota.localizado = false
        } else if (xhr.status == 401) {
          swal({
            title: 'É necessário estar logado',
            icon: 'warning',
          }).then(() => (location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href))
        } else {
          swal({
            title: 'Erro ao buscar a nota fiscal',
            icon: 'error',
          })
        }
      }

      // xhr.onloadend = () => {
      //   let xhrDownload = new XMLHttpRequest()
      //   xhrDownload.onreadystatechange = () => {
      //     if (xhrDownload.readyState == 4 && xhrDownload.status == 200 && this.frmPesquisaNota.localizado) {
      //       let json = JSON.parse(xhrDownload.responseText)

      //       this.frmPesquisaNota.xml = json[0]
      //       this.frmPesquisaNota.pdf = json[1]
      //     } else {
      //       this.frmPesquisaNota.xml = null
      //       this.frmPesquisaNota.pdf = null
      //     }
      //   }

      //   xhrDownload.open('POST', this.$apiUrl + 'PedidosVenda.svc/downloaddanfe')
      //   xhrDownload.setRequestHeader('Content-type', 'application/json')
      //   xhrDownload.withCredentials = true

      //   xhrDownload.send(
      //     JSON.stringify({
      //       chave: this.frmPesquisaNota.chave,
      //     })
      //   )
      // }

      xhr.open('POST', this.$apiUrl + 'PedidosVenda.svc/getpedidodanfe')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoNotaFiscal: this.frmPesquisaNota.nota,
          codigoPedido: 0,
        })
      )
    },
    getDados: function () {
      const Registros = [
        {
          data: '22/10/2018',
          descricao: 'Valor Comprado + Bônus de A$ 1,05',
          ativo: 'Sim',
          valor: 3920.79,
        },
        {
          data: '10/10/2018',
          descricao: 'Valor Comprado + Bônus de A$ 1,05',
          ativo: 'Sim',
          valor: 1118.62,
        },
        {
          data: '11/2/2019',
          descricao: 'Valor Comprado + Bônus de A$ 1,05',
          ativo: 'Sim',
          valor: -300.0,
        },
        {
          data: '22/10/2018',
          descricao: 'Valor Comprado + Bônus de A$ 1,05',
          ativo: 'Sim',
          valor: 3920.79,
        },
        {
          data: '10/10/2018',
          descricao: 'Valor Comprado + Bônus de A$ 1,05',
          ativo: 'Sim',
          valor: 1118.62,
        },
        {
          data: '11/2/2019',
          descricao: 'Saldo do Aldo Crazy Card após a Solicitação: 41464, é de A$ 115000,00',
          ativo: 'Sim',
          valor: -300.0,
        },
      ]

      return Registros
    },
    setupDownload: function (xml, obj, propriedade, extensao, chave) {
      DownloadDanfeService.SetupDownload(xml, obj, propriedade, extensao, chave, this, this[obj].localizado)
    },
  },
}
</script>
